import { render } from "./Join2.vue?vue&type=template&id=2439f651"
import script from "./Join2.vue?vue&type=script&lang=js"
export * from "./Join2.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__